import type { Env } from "@/env.service";
import { AttachmentRepository } from "./implementations/attachment.repository";
import { CompanyGroupRepository } from "./implementations/company-group-repository";
import { CompanyRepository } from "./implementations/company-repository";
import { ControlRepository } from "./implementations/control-repository";
import { ControlResultRepository } from "./implementations/control-result-repository";
import { PriorityRepository } from "./implementations/priority.repository";
import { RoleRepository } from "./implementations/role-repository";
import { UserGroupRepository } from "./implementations/user-group-repository";
import { UserRepository } from "./implementations/user-repository";
import type { RepositoryContainer } from "./repository-container";

export function createProductionRepositories(): RepositoryContainer {
  return {
    companyGroupRepository: new CompanyGroupRepository(),
    companyRepository: new CompanyRepository(),
    controlRepository: new ControlRepository(),
    roleRepository: new RoleRepository(),
    userRepository: new UserRepository(),
    userGroupRepository: new UserGroupRepository(),
    controlResultRepository: new ControlResultRepository(),
    attachmentRepository: new AttachmentRepository(),
    priorityRepository: new PriorityRepository(),
  };
}

// For different environments
export function createRepositories(
  env: Env["envName"] = "production",
): RepositoryContainer {
  switch (env) {
    default:
      return createProductionRepositories();
  }
}
